import config from '../../../config/config.json';

export const CONTEXT_ROOT = config.express.mountpath;
export const COMPONENT = 'nocodenodeweb';
export const PRODUCT = 'quantum_leap';

// Account Types
export const BUSINESS = 'BUSINESS';
export const INDIVIDUAL = 'INDIVIDUAL';

export const fptiPageNames = {
  hostedExp: 'container'
};

export const FPTI_GROUP = 'main:business:web:hostedcheckout';

export const facebookApplicationId = '1084613224964631';
export const facebookShareLink = 'https://www.facebook.com/dialog/share';
export const twitterShareLink = 'https://twitter.com/share';
export const whatsappShareLink = 'https://web.whatsapp.com/send';
